import "./UploadAndPreview.scss"
import React, { useRef, useState } from 'react'
import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useToggle } from '../../hooks'
import FileUploaderInputField from '../file-uploader-input-field/FileUploaderInputField'
import PreviewModal from '../PreviewModal'
import { toBase64, urltoFile } from '../../utilities/index'
import { ReactComponent as PencilIcon } from '../../assets/attendance-portal/PencilIcon.svg'
import { classNames } from "primereact/utils"
import PrimeInputText from "../prime-react-overrides/input-text/InputText"



function UploadAndPreview({ docData, maxFileSize, className, withOutMargin, VerticalAlignment, setDocData, setIsDocUploaded, title, acceptType, onReset = () => { } }) {
  const [showModal, setModal] = useToggle(false)
  const uploadInput = useRef(null)
  const [FileDoc, setFileDoc] = useState({})
  const [fileType, setFileType] = useState('')
  const [fileName, setFileName] = useState('')
 


  useEffect(async () => {
    if (docData.link && docData.name && docData.type) {
      let docFile = await urltoFile(docData.link, docData.name, docData.type);
      if (docFile.name) {
        docData.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? setFileDoc(docFile) : setFileDoc(URL.createObjectURL(docFile))
        
        setFileName(docData.name)
        setFileType(docData.type);
      }
    }
  }, [docData])


  const showError = () => {
    toast.error("Format should be in acceptable format under 2MB")
  }


  const onSelect = async (e) => {
    if (!e.files[0]) {
      showError()
    }
    let type = e.files[0].type;
    let name = e.files[0].name;
    toBase64(e.files[0]).then((link) => {
      if (acceptType.includes(type) || acceptType.includes("*")) {
        return setDocData({ link, name, type });
      }
      onValidationFail(e)
      showError()
      setDocData(null, '', '')
    });
  }
  const onValidationFail = (e) => {
    uploadInput.current.clear()
  }

  let content = (
    <FileUploaderInputField
      ref={uploadInput}
      accept={acceptType.toString()}
      maxFileSize={maxFileSize}
      onSelect={onSelect}
      onValidationFail={onValidationFail}
      customUpload={true}
      type={fileType}
      name={fileName}
    />
  )

  if (docData.link && docData.name) {
    let _tempName = docData.name.length <= 12 ? docData.name : `${docData.name.substr(0, 20)}...`
    content = (
      <div onClick={onReset} className='cursor-pointer'>
        <PrimeInputText
          value={_tempName} className='p-disabled inputTextStyle'
          // tooltip='Reset and start again?' 
          // tooltipOptions={{ showOnDisabled: true }}
          rightIcon={<PencilIcon className="PencilSvg" />} rightIconContainerClass='w-full'
        />
      </div>
    )
  }

  return (
    <div className={classNames('UploadAndPreview', className)}>
      <PreviewModal onHide={setModal} header="Preview Modal" visible={showModal} type={fileType} documentData={FileDoc} name={fileName} />
      <div className={classNames("grid align-items-center mx-0 ", { "flex-column": VerticalAlignment })}>
        <div className="field col w-full" >
          <h6 className='text-sm font-normal'>{title}</h6>
          {content}
        </div>
        <div className={`col w-full  `}>
          <h6 className={`Preview text-sm font-normal mt-6 underline cursor-pointer ${docData.link ? '' : 'hidden'}`} onClick={setModal}>Preview</h6>
        </div>
      </div>
    </div>
  )
}

UploadAndPreview.defaultProps = {
  acceptType: ["*"],
  withOutMargin: false,
  VerticalAlignment: false,
  onReset: () => { }
}

export default UploadAndPreview